import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MaterialTable, { MTableToolbar } from 'material-table';

class ReferralSources extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data:[],
      columns: [
        // { title: 'ID', field: 'id' },
        { title: 'Description', field: 'description' },
      ],
    };
  }
    
  componentDidMount() {
    var params = {
      'tablename': this.props.referralsources.tablename
    }
    this.props.getReferralSources(params);
  }

  render() {
    return (
      <div style={{ maxWidth: '100%' }}>
          <MaterialTable
            title="Referral Sources"
            columns={this.state.columns}
            data={this.props.referralsources.referralsources}

            options={{
              // search
              search: true,
              // header grouping
              // grouping: true,
              // or              
              // column filtering
              // filtering: true,
              
              // pagination settings
              // show paging buttons
              // paging:false,
              // default items per page
              pageSize:30,
              // paging options
              pageSizeOptions:[30,60,90,120],

              // ???
              // columnsButton:false,
              // move buttons to right side of list
              // actionsColumnIndex: -1, 

              // styling otions
              rowStyle:{height:"20px"},
              maxBodyHeight: 700,
              
              // CSV export
              // exportButton: true,
              // default filename
              exportFileName: 'CPCMexport-ReferralSources',
              // comma delimited
              // exportDelimiter: ',', 

            }}

          // custom Toolbar
          components={{
            Toolbar: props => (
              <div style={{
                background: 'linear-gradient(45deg, #f48fb1 10%, #fff 70%)', // blue / fade light blue
                color: 'white',
              }}>
                  <MTableToolbar {...props} />
              </div>
            )
          }}

          // add , update , and delete 
          editable={{
            onRowAdd: newData =>
              new Promise((resolve, reject) => {                
                var params = {
                  'description': newData.description
                  , 'tablename': this.props.referralsources.tablename
                }
                this.props.addReferralSources(params);              
                  // add to state
                  const data = this.state.data;
                  data.push(newData);
                  this.setState({ data }, () => resolve());                  
              }),
            onRowUpdate: (newData, oldData) =>
              new Promise((resolve, reject) => {
                var params = {
                  'description': newData.description
                  , 'tablename': this.props.referralsources.tablename
                }
                this.props.updateReferralSources(newData.id,params);                 
                  // update the state
                  const data = this.state.data;
                  const index = data.indexOf(oldData);
                  data[index] = newData;
                  this.setState({ data }, () => resolve());
              }),
            // onRowDelete: oldData =>
            //   new Promise((resolve, reject) => {
            //     var params = {
            //       'tablename': this.props.referralsources.tablename
            //     }
            //     this.props.deleteReferralSources(oldData.id,params);
            //       // remove from state
            //       let data = this.state.data;
            //       const index = data.indexOf(oldData);
            //       data.splice(index, 1);
            //       this.setState({ data }, () => resolve());
            //   }),
          }}

        />
      </div>
    );
  }
}

ReferralSources.propTypes = {
  className: PropTypes.string,
};

export default ReferralSources;